<template>
    <div class="col-xxl-4 col-md-6 col-sm-12">
        <div class="btn-group btn-option" data-bs-toggle="buttons">
            <div class="btn btn-danger">
                <div class="checkbox checkbox-danger">
                    <input id="checkbox-danger-11" type="checkbox">
                    <label for="checkbox-danger-11">Option 1</label>
                </div>
            </div>
            <div class="btn btn-danger">
                <div class="checkbox checkbox-danger">
                    <input id="checkbox-danger-12" type="checkbox">
                    <label for="checkbox-danger-12">Option 2</label>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xxl-4 col-md-6 col-sm-12 button-group-mb-sm">
        <div class="btn-group btn-option" data-bs-toggle="buttons">
            <div class="btn btn-light txt-dark">
                <div class="checkbox checkbox-light">
                    <input id="checkbox-light-13" type="checkbox">
                    <label for="checkbox-light-13">Option 1</label>
                </div>
            </div>
            <div class="btn btn-light txt-dark">
                <div class="checkbox checkbox-light">
                    <input id="checkbox-light-14" type="checkbox">
                    <label for="checkbox-light-14">Option 2</label>
                </div>
            </div>
        </div>
    </div>
</template>